// Companion device type enum - moved here to avoid circular dependencies
export enum CompanionDeviceType {
  TV = 'tv',
  SELF_CHECKOUT = 'self-checkout',
  CUSTOMER_FACING = 'customer-facing',
  DIGITAL_SIGNAGE = 'digital-signage',
}
